import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadCurrentStore, loadCurrentStoreSettingsSetup, updateStore } from '../../services/store';


export const getCurrentStore = createAsyncThunk(
  'store/getCurrentStore',
  async (storeId?: string) => {
    const store = await loadCurrentStore(storeId);
    return store || {};
  },
);

export const updateCurrentStore = createAsyncThunk(
  'store/updateCurrentStore',
  async (data: any) => {
    const store = await updateStore(data);
    return store || {};
  },
);

export const getCurrentStoreSettingsSetup = createAsyncThunk(
  'store/getCurrentStoreSettingsSetup',
  async () => {
    const settingsSetup = await loadCurrentStoreSettingsSetup();
    return settingsSetup || {};
  },
);

